import dispatcher from "../appDispatcher";
import actionTypes from "./actionTypes";

export function updateObjectionDetailsHelper(objectionDetailsHelper) {
  dispatcher.dispatch({
    actionType: actionTypes.UPDATE_OBJECTION_DETAILS_HELPER,
    objectionDetailsHelper: objectionDetailsHelper,
  });
}
